module.exports = __webpack_public_path__ + "static/media/double_pen.03e42ad0.svg";